// extracted by mini-css-extract-plugin
export default {"linkCSS":"sustainabilityListItem_linkCSS__G0ZXj","titleSmallDot":"sustainabilityListItem_titleSmallDot__6Renx","listItemContainer":"sustainabilityListItem_listItemContainer__5OEPD"};